import Dayjs from 'dayjs'
import { store as notificationStore } from 'react-notifications-component'

import { sendOtp as sendOtpApi, verifyOtp } from 'api'
import constants from 'app/constants'
import { getNewAccessToken, notify, setCookie } from 'app/helpers'
import { decodeJWT } from 'app/utils'
import { setSentryUser } from 'sentry'

import {
  loggingIn,
  loginFailed,
  loginSuccess,
  loginWithCookieFailed,
  loginWithCookieStart,
  loginWithCookieSuccess,
  logoutSuccess,
  sendOtpFailed,
  sendOtpSuccess,
  sendingOtp
} from '../actions/auth'

export function loginWithCookie() {
  return (dispatch) => {
    dispatch(loginWithCookieStart())
    return getNewAccessToken()
      .then((data) => {
        if (data && data.access_token !== '' && data.access_token) {
          const user = decodeJWT(data.access_token)
          dispatch(loginWithCookieSuccess({ ...data, number: user.username }))
        } else {
          dispatch(loginWithCookieFailed('Unable to verify user'))
        }
        return data
      })
      .catch((error) => {
        dispatch(loginWithCookieFailed('Unable to verify user'))
        return error
      })
  }
}

export function sendOtp(phone_number) {
  return (dispatch) => {
    dispatch(sendingOtp())
    return sendOtpApi({ phone_number })
      .then((data) => {
        notificationStore.removeNotification(1)
        dispatch(sendOtpSuccess(data.user))
        return data
      })
      .catch((error) => {
        dispatch(sendOtpFailed(constants.ERROR_MESSAGE))
        return error
      })
  }
}

export function login(phone_number, otp) {
  return (dispatch) => {
    dispatch(loggingIn())
    return verifyOtp({ phone_number, otp })
      .then((data) => {
        if (data.access_token) {
          let user = decodeJWT(data.access_token)
          let isValidAdmin = user.realm_access?.roles?.includes('admin')
          if (!isValidAdmin) {
            isValidAdmin = false
            notify("You don't have access to this panel.", '', 'danger')
          } else {
            setCookie(constants.ACCESS_TOKEN_KEY, data.access_token)
            setCookie(constants.REFRESH_TOKEN_KEY, data.refresh_token)
            setCookie(
              constants.REFRESH_TOKEN_LAST_UPDATED,
              new Dayjs().format('YYYY/MM/DD HH:mm:ss')
            )
            setCookie(constants.USER_NUMBER, user.username)
          }
          data.isValidAdmin = isValidAdmin
          setSentryUser(user.sub)
          dispatch(loginSuccess({ ...data, number: user.username }))
        } else {
          let _error = data.error_description || constants.ERROR_MESSAGE
          dispatch(loginFailed(_error))
        }
        return data
      })
      .catch((error) => {
        dispatch(loginFailed(constants.ERROR_MESSAGE))
        return error
      })
  }
}

export function logout() {
  return (dispatch) => {
    setCookie(constants.ACCESS_TOKEN_KEY, '')
    setCookie(constants.REFRESH_TOKEN_KEY, '')
    setCookie(constants.REFRESH_TOKEN_LAST_UPDATED, '')
    setCookie(constants.USER_NUMBER, '')
    dispatch(logoutSuccess())
  }
}
